import { gettext } from '@eventbrite/i18n';
import { Timeframe, TimeframesMap } from './types';

export const formatSearchUrl = (location: string, term: string) =>
    `/d/${location}/${term}/`;
export const timeframesMap: TimeframesMap = {
    day: gettext('Daily'),
    week: gettext('Weekly'),
    month: gettext('Monthly'),
    year: gettext('Yearly'),
};

export const formatPageTitle = (location: string, timeframe: Timeframe) => {
    const ordinalTimeframe = timeframesMap[timeframe] || timeframesMap.week;

    return location === 'Online'
        ? gettext('%(ordinalTimeframe)s trending searches for Online Events', {
              ordinalTimeframe,
          })
        : gettext('%(ordinalTimeframe)s trending searches in %(location)s', {
              ordinalTimeframe,
              location,
          });
};

export const formatTrendingSearchPageTitle = (location: string) => {
    return location === 'Online'
        ? gettext('Trending searches for Online Events')
        : gettext('Trending searches in %(location)s', {
              location,
          });
};
